import clearCache from "web/utils/system/essentials/clearCache";
import BrowserPersistence from "web/utils/system/storage/storage/browserPersistence";

import storageNames from "web/constants/storageNames";

import { Nullable } from "web/types/Utils";

import getLogoutUrl from "./getLogoutUrl";
import newRelicErrorReport from "./newRelicErrorReport";

const storage = new BrowserPersistence();

const logout = async (
  paramsAdditional?: string,
  idTokenHint?: Nullable<string>,
  logoutId?: string
) => {
  const idToken = storage.getItem(storageNames.idToken) || idTokenHint;
  const logoutUrl = getLogoutUrl(paramsAdditional, idTokenHint);

  if (idToken) {
    await clearCache();
    return window.location.replace(logoutUrl);
  }

  newRelicErrorReport(new Error("no idToken"), logoutId);
  return window.location.replace(logoutUrl);
};

export default logout;
